import React from 'react';

import { createSafeContext } from '@boc/framework/safe-context';

import { useProductDetails } from '~/framework/routes/products/providers';

const [useQuantity, Provider] = createSafeContext<{
  quantity: number;
  setQuantity: React.Dispatch<React.SetStateAction<number>>;
}>();

const Quantity = ({ children }: { children: React.ReactNode }) => {
  const { quantity, setQuantity } = useProductDetails();

  return (
    <Provider value={{ quantity, setQuantity }}>
      <div className="flex items-center space-x-4">{children}</div>
    </Provider>
  );
};

const QuantityButton = ({
  update,
  disabled,
  children,
}: {
  update: (quantity: number) => number;
  disabled: (quantity: number) => boolean;
  children: React.ReactNode;
}) => {
  const { quantity, setQuantity } = useQuantity();

  return (
    <button
      className="bg-primary-2-80 text-neutral-1 hover:bg-secondary-1 flex h-6 w-6 place-content-center items-center rounded-full"
      disabled={disabled(quantity)}
      onClick={() => setQuantity(update)}
    >
      {children}
    </button>
  );
};

const Plus = () => {
  const update = React.useCallback((quantity: number) => quantity + 1, []);

  return (
    <QuantityButton update={update} disabled={() => false}>
      +
    </QuantityButton>
  );
};

const Minus = () => {
  const update = React.useCallback((quantity: number) => Math.max(quantity - 1, 1), []);

  return (
    <QuantityButton update={update} disabled={() => false}>
      -
    </QuantityButton>
  );
};

const Value = () => {
  const { quantity } = useQuantity();

  return <div className="flex w-4 place-content-center">{quantity}</div>;
};

Quantity.Plus = Plus;
Quantity.Minus = Minus;
Quantity.Value = Value;

export default Quantity;
